var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GradientBarComponent',{attrs:{"labels":[
    '0.0',
    '0.01',
    '0.2',
    '0.4',
    '0.6',
    '0.8',
    '1',
    '1.15',
    '1.6',
    '2.3',
    '3.1',
    '3.89' ],"gradientColors":[
    '#00264d',
    '#005580',
    '#007399',
    '#0099b3',
    '#00b3cc',
    '#66d9e8',
    '#c2eeb0',
    '#ffff99',
    '#ffd699',
    '#ffad66',
    '#ff704d',
    '#e64d2e' ],"unit":"kn"}})}
var staticRenderFns = []

export { render, staticRenderFns }